import React, { Component } from 'react';
import _ from 'lodash';
import { post, get } from '../../util/api';
import { Box, Button, TableBody, TableCell, TableHead, TableRow, Table, Typography, TextField } from '@mui/material';

class SubsTable extends Component {
	state = {
		column: null,
		direction: null,
		loading: true,
		// varsayilan arama baslangici: son 24 saat
		paddleStart: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString().slice(0, 10),
	};
	handleChange = (e) => this.setState({ [e.target.name]: e.target.value });
	componentDidMount() {
		this.getData(1);
	}
	async getData(page = 1) {
		this.setState({ loading: true });
		let search = (this.state.searchInput || '').trim();
		// arama yaparken phone_limit>0 filtresini kapat; limiti 0 kalmis (duzeltilecek) hesaplar da gelsin
		let params = `?page=${page}&limit=50&source=maytapi${search ? `&search=${encodeURIComponent(search)}&hasPhoneLimit=false` : ''}`;
		await get(`/maytapi/admin/subsList${params}`).then((data) =>
			this.setState({ data: data.result, pagination: data.pagination, page: page, loading: false })
		);
	}
	handleSearch = (e) => {
		if (e) e.preventDefault();
		this.getData(1);
	};
	refresh() {
		setTimeout(() => {
			window.location.reload(false);
		}, 1000);
	}
	addProduct = () => {
		this.setState({ btnloading: true });
		let { pid, agentQuantity, phoneQuantity, instagramQuantity } = this.state;
		post('/maytapi/admin/setPackage', {
			pid: pid,
			new_limit: parseInt(agentQuantity),
			new_phone_limit: parseInt(phoneQuantity),
			new_instagram_limit: parseInt(instagramQuantity),
			subscription_plan_id: 'maytapi-custom-api',
		}).then((data) => {
			if (data.data.success) {
				this.setState({ btnloading: false });
				this.refresh();
			} else {
				this.setState({ btnloading: false, errMessage: data.data.error });
			}
		});
	};
	selectProduct(value) {
		this.setState({
			pid: value.pid,
			agentQuantity: value.agentQuantity || 0,
			phoneQuantity: value.phoneQuantity || 0,
			instagramQuantity: value.instagramQuantity || 0,
			plan_id: 'custom',
			email: value.email,
			paddleEmail: value.email,
			paddleLogs: null,
			paddleNextPage: null,
			paddleMsg: null,
			subsMsg: null,
		});
		this.loadSubs(value.pid);
	}
	loadSubs = (pid) => {
		this.setState({ subs: null, subsLoading: true });
		get(`/maytapi/admin/customer/${pid}/subscriptions`).then((d) => {
			let subs = (d && d.subscriptions) || [];
			let next = { subs, subsLoading: false };
			// input state'lerini mevcut custom_data ile doldur
			for (let s of subs) {
				next[`cd_phone_${s.id}`] = (s.custom_data && s.custom_data.phone_limit) || 0;
				next[`cd_agent_${s.id}`] = (s.custom_data && s.custom_data.agent_limit) || 0;
			}
			this.setState(next);
		});
	};
	saveCustomData = (sub, clear = false) => {
		let { pid } = this.state;
		if (clear && !window.confirm(`custom_data silinsin mi? (sub: ${sub.charge_id || sub.id})`)) return;
		this.setState({ subsSaving: sub.id, subsMsg: null });
		post('/maytapi/admin/subCustomData', {
			pid,
			sub_id: sub.id,
			custom_data: clear
				? null
				: {
						phone_limit: parseInt(this.state[`cd_phone_${sub.id}`]) || 0,
						agent_limit: parseInt(this.state[`cd_agent_${sub.id}`]) || 0,
				  },
		}).then((data) => {
			let d = data.data;
			this.setState({ subsSaving: null, subsMsg: d.success ? 'custom_data kaydedildi, limitler yenilendi ✓' : `Hata: ${d.error}` });
			if (d.success) this.loadSubs(pid);
		});
	};
	searchPaddleLogs = (more = false) => {
		let { paddleEmail, paddleStart, paddleEnd, paddleNextPage, paddleLogs } = this.state;
		if (!paddleEmail) return;
		this.setState({ paddleLoading: true, paddleMsg: null });
		post('/maytapi/admin/paddleWebhookLogs', {
			email: paddleEmail,
			start_date: paddleStart || undefined,
			end_date: paddleEnd || undefined,
			page: more && paddleNextPage ? paddleNextPage : 1,
		}).then((data) => {
			let d = data.data;
			if (d.success) {
				this.setState({
					paddleLogs: more ? [...(paddleLogs || []), ...d.alerts] : d.alerts,
					paddleNextPage: d.next_page,
					paddleLoading: false,
					paddleMsg: `${d.scanned_pages} sayfa tarandı${d.next_page ? ', devamı var' : ''}`,
				});
			} else {
				this.setState({ paddleLoading: false, paddleMsg: d.error });
			}
		});
	};
	applyPaddleLog = (alert) => {
		let { pid, email } = this.state;
		if (!pid) return;
		let f = alert.fields || {};
		let alertName = alert.alert_name || f.alert_name;
		if (!window.confirm(`${alertName} (sub: ${f.subscription_id || '-'}) → ${email} (pid: ${pid}) hesabına işlensin mi?`)) return;
		this.setState({ paddleApplying: alert.id });
		post('/maytapi/admin/applyPaddleWebhook', { pid, alert }).then((data) => {
			let d = data.data;
			this.setState({
				paddleApplying: null,
				paddleMsg: d.success ? `${alertName} işlendi (${d.action}) ✓` : `Hata: ${d.error}`,
			});
			// yeni islenen abonelik custom_data karti olarak da gorunsun
			if (d.success) this.loadSubs(pid);
		});
	};
	handleSort = (clickedColumn, data) => () => {
		const { column, direction } = this.state;
		if (column !== clickedColumn) {
			this.setState({
				column: clickedColumn,
				data: _.sortBy(data, [clickedColumn]),
				direction: 'ascending',
			});

			return;
		}

		this.setState({
			data: data.reverse(),
			direction: direction === 'ascending' ? 'descending' : 'ascending',
		});
	};
	TableLineCustom = (data) =>
		_.map(data, (val, index) => (
			<TableRow key={val && val.owner_id}>
				<TableCell>{index + 1}</TableCell>
				<TableCell>{val && val.owner_id}</TableCell>
				<TableCell>{val && val.owner_email}</TableCell>
				<TableCell>{val && val.package}</TableCell>
				<TableCell>{val && val.agent_limit}</TableCell>
				<TableCell>{val && val.phone_limit}</TableCell>
				<TableCell>{val && val.instagram_limit}</TableCell>
				<TableCell>{(val && val.agents && val.agents.length) || 0}</TableCell>
				<TableCell>{(val && val.phones && val.phones.length) || 0}</TableCell>
				<TableCell>{(val && val.instagrams && val.instagrams.length) || 0}</TableCell>
				<TableCell>
					<Button
						disabled={val.is_reseller || val.is_enterprise}
						onClick={() =>
							this.selectProduct({
								email: val.owner_email,
								pid: val.pid,
								agentQuantity: val.agent_limit,
								phoneQuantity: val.phone_limit,
								instagramQuantity: val.instagram_limit,
								plan_id: val.package,
							})
						}
					>
						Edit
					</Button>
				</TableCell>
			</TableRow>
		));
	render() {
		let { loading, data, column, direction } = this.state;
		console.log('data', data);
		let dg = _.map(data, function (it) {
			it = {
				agent_limit: it.agent_limit || 0,
				phone_limit: it.phone_limit || 0,
				instagram_limit: it.instagram_limit || 0,
				owner_id: it.owner_id,
				owner_name: it.owner_name,
				owner_email: it.owner_email,
				pid: it.pid,
				token: it.token,
				agents: it.agents,
				phones: it.phones,
				instagrams: it.intagrams,
				package: it.package,
				verified: it.verified,
				total_agent: it.total_agent,
				wapi_pid: it.wapi_pid,
				wapi_token: it.wapi_token,
			};
			return it;
		});
		let { pagination, page } = this.state;
		return (
			<Box attached="bottom" style={{ display: 'flex', maxHeight: '800px' }}>
				<div attached="bottom" style={{ width: '75%', padding: '0', overflow: 'auto' }}>
					<Box
						component="form"
						onSubmit={this.handleSearch}
						style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px', position: 'sticky', left: 0 }}
					>
						<TextField
							size="small"
							variant="outlined"
							name="searchInput"
							label="Search (email / name / pid)"
							value={this.state.searchInput || ''}
							onChange={this.handleChange}
							style={{ width: '280px' }}
						/>
						<Button variant="outlined" size="small" type="submit" disabled={loading}>
							Search
						</Button>
						<div style={{ flex: 1 }} />
						<Button size="small" disabled={loading || !pagination || !pagination.hasPrev} onClick={() => this.getData(page - 1)}>
							&lt; Prev
						</Button>
						<Typography variant="body2">
							{pagination ? `${pagination.page} / ${pagination.totalPages} — ${pagination.total} hesap` : ''}
						</Typography>
						<Button size="small" disabled={loading || !pagination || !pagination.hasNext} onClick={() => this.getData(page + 1)}>
							Next &gt;
						</Button>
					</Box>
					{loading && <Box style={{ padding: '16px' }}>loading...</Box>}
					{!loading && (
					<Table celled sortable>
						<TableHead>
							<TableRow>
								<TableCell>#</TableCell>
								<TableCell sorted={column === 'owner_id' ? direction : null} onClick={this.handleSort('owner_id', dg)}>
									Id
								</TableCell>
								<TableCell sorted={column === 'owner_email' ? direction : null} onClick={this.handleSort('owner_email', dg)}>
									Email
								</TableCell>
								<TableCell sorted={column === 'package' ? direction : null} onClick={this.handleSort('package', dg)}>
									Package
								</TableCell>
								<TableCell sorted={column === 'agent_limit' ? direction : null} onClick={this.handleSort('agent_limit', dg)}>
									Agent Limit
								</TableCell>
								<TableCell sorted={column === 'phone_limit' ? direction : null} onClick={this.handleSort('phone_limit', dg)}>
									Phone Limit
								</TableCell>
								<TableCell sorted={column === 'instagram_limit' ? direction : null} onClick={this.handleSort('instagram_limit', dg)}>
									Instagram Limit
								</TableCell>
								<TableCell sorted={column === 'agents' ? direction : null} onClick={this.handleSort('agents', dg)}>
									Agents
								</TableCell>
								<TableCell sorted={column === 'phones' ? direction : null} onClick={this.handleSort('phones', dg)}>
									Phones
								</TableCell>
								<TableCell sorted={column === 'instagrams' ? direction : null} onClick={this.handleSort('instagrams', dg)}>
									Instagram
								</TableCell>
								<TableCell></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>{this.TableLineCustom(dg)}</TableBody>
					</Table>
					)}
				</div>
				<Box className="left-menu" style={{ marginTop: '0', width: '25%', maxHeight: '786px', padding: '0 20px', overflowY: 'auto' }}>
					<Typography variant="h5" gutterBottom component="div">
						Edit
					</Typography>
					<Box
						component="form"
						sx={{
							'& > :not(style)': { m: 1 },
						}}
						noValidate
						autoComplete="off"
						onSubmit={this.addProduct}
					>
						<TextField fullWidth variant="outlined" readOnly label="Email" value={this.state.email} focused={!!this.state.email} required />
						<TextField fullWidth variant="outlined" readOnly label="Pid" value={this.state.pid} focused={!!this.state.pid} required />
						<TextField
							fullWidth
							variant="outlined"
							name="agentQuantity"
							type="number"
							label="Agent Quantity"
							disabled={!this.state.pid}
							focused={!!this.state.pid}
							required
							value={this.state.agentQuantity}
							onChange={this.handleChange}
						/>
						<TextField
							fullWidth
							variant="outlined"
							name="phoneQuantity"
							type="number"
							label="Phone Quantity"
							disabled={!this.state.pid}
							focused={!!this.state.pid}
							required
							value={this.state.phoneQuantity}
							onChange={this.handleChange}
						/>
						<TextField
							fullWidth
							variant="outlined"
							name="instagramQuantity"
							type="number"
							label="Instagram Quantity"
							disabled={!this.state.pid}
							focused={!!this.state.pid}
							required
							value={this.state.instagramQuantity}
							onChange={this.handleChange}
						/>
						<div className="d-flex">
							<Button positive content="Save" type="submit" style={{ width: '100px' }} disabled={!this.state.pid} loading={this.state.btnloading}>
								Save
							</Button>
						</div>
					</Box>
					{this.state.pid && (
						<>
							<Typography variant="h6" gutterBottom component="div" style={{ marginTop: '16px' }}>
								Subscriptions / Custom Data
							</Typography>
							<Box sx={{ '& > :not(style)': { m: 1 } }}>
								{this.state.subsLoading && <Typography variant="body2">loading...</Typography>}
								{this.state.subs && !this.state.subs.length && !this.state.subsLoading && <Typography variant="body2">Subscription yok.</Typography>}
								{this.state.subsMsg && (
									<Typography variant="body2" color="textSecondary">
										{this.state.subsMsg}
									</Typography>
								)}
								{_.map(this.state.subs, (sub) => {
									let d = sub.data || {};
									return (
										<Box key={sub.id} style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '8px', fontSize: '13px' }}>
											<div style={{ fontWeight: 600 }}>
												{d.subscription_plan_id || '-'} {sub.trial ? '(trial)' : ''}
											</div>
											<div>
												sub: {sub.charge_id || '-'} | status: {d.status || '-'} | qty: {d.new_quantity || d.quantity || '-'}
											</div>
											<div style={{ marginBottom: '4px' }}>custom_data: {sub.custom_data ? JSON.stringify(sub.custom_data) : '-'}</div>
											<div style={{ display: 'flex', gap: '8px' }}>
												<TextField
													size="small"
													variant="outlined"
													name={`cd_phone_${sub.id}`}
													type="number"
													label="Phone Limit"
													value={this.state[`cd_phone_${sub.id}`] || 0}
													onChange={this.handleChange}
												/>
												<TextField
													size="small"
													variant="outlined"
													name={`cd_agent_${sub.id}`}
													type="number"
													label="Agent Limit"
													value={this.state[`cd_agent_${sub.id}`] || 0}
													onChange={this.handleChange}
												/>
											</div>
											<div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
												<Button size="small" variant="contained" disabled={this.state.subsSaving === sub.id} onClick={() => this.saveCustomData(sub)}>
													{this.state.subsSaving === sub.id ? 'Kaydediliyor...' : 'Kaydet'}
												</Button>
												{sub.custom_data && (
													<Button size="small" color="error" disabled={this.state.subsSaving === sub.id} onClick={() => this.saveCustomData(sub, true)}>
														Kaldır
													</Button>
												)}
											</div>
										</Box>
									);
								})}
							</Box>
						</>
					)}
					<Typography variant="h6" gutterBottom component="div" style={{ marginTop: '16px' }}>
						Paddle Webhook Logs
					</Typography>
					<Box sx={{ '& > :not(style)': { m: 1 } }}>
						<TextField
							fullWidth
							size="small"
							variant="outlined"
							name="paddleEmail"
							label="Email"
							value={this.state.paddleEmail || ''}
							onChange={this.handleChange}
						/>
						<div style={{ display: 'flex', gap: '8px' }}>
							<TextField
								size="small"
								variant="outlined"
								name="paddleStart"
								type="date"
								label="Start"
								InputLabelProps={{ shrink: true }}
								value={this.state.paddleStart || ''}
								onChange={this.handleChange}
							/>
							<TextField
								size="small"
								variant="outlined"
								name="paddleEnd"
								type="date"
								label="End"
								InputLabelProps={{ shrink: true }}
								value={this.state.paddleEnd || ''}
								onChange={this.handleChange}
							/>
						</div>
						<Button variant="outlined" size="small" disabled={!this.state.paddleEmail || this.state.paddleLoading} onClick={() => this.searchPaddleLogs(false)}>
							{this.state.paddleLoading ? 'Searching...' : 'Search'}
						</Button>
						{this.state.paddleMsg && (
							<Typography variant="body2" color="textSecondary">
								{this.state.paddleMsg}
							</Typography>
						)}
						{this.state.paddleLogs && !this.state.paddleLogs.length && !this.state.paddleLoading && (
							<Typography variant="body2">Kayıt bulunamadı.</Typography>
						)}
						{_.map(this.state.paddleLogs, (log) => {
							let f = log.fields || {};
							return (
								<Box key={log.id} style={{ border: '1px solid #ddd', borderRadius: '6px', padding: '8px', fontSize: '13px' }}>
									<div style={{ fontWeight: 600 }}>{log.alert_name || f.alert_name}</div>
									<div>{log.created_at}</div>
									<div>
										sub: {f.subscription_id || '-'} | plan: {f.subscription_plan_id || '-'} | qty: {f.new_quantity || f.quantity || '-'} | {f.status || '-'}
									</div>
									<Button
										size="small"
										variant="contained"
										style={{ marginTop: '4px' }}
										disabled={!this.state.pid || this.state.paddleApplying === log.id}
										onClick={() => this.applyPaddleLog(log)}
									>
										{this.state.paddleApplying === log.id ? 'Ekleniyor...' : 'Ekle'}
									</Button>
								</Box>
							);
						})}
						{this.state.paddleNextPage && (
							<Button size="small" disabled={this.state.paddleLoading} onClick={() => this.searchPaddleLogs(true)}>
								Devamını tara
							</Button>
						)}
					</Box>
				</Box>
			</Box>
		);
	}
}

export default SubsTable;
